import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import mainBg from "../../../assets/img/banner/main-bg.jpg";

import banner1 from "../../../assets/img/banner/banner1.png";
import banner2 from "../../../assets/img/banner/banner2.png";
// import banner from "../../../assets/img/banner/slider-new3.jpg";

import baby from "../../../assets/img/banner/baby.jpg";

import "./Banner.css";
import { Link } from "react-router-dom";
import { useGetBannerQuery } from "./bannerSlice";
import axios from "axios";
import { bannerDB } from "../../../rki-data/banner";
import { isMobile } from "react-device-detect";
import { base_url } from "../../../server";
const bannerData = bannerDB;
function Banner() {
  const [data, setData] = useState();
  const baseUrl = base_url();

  var settings = {
    dots: false,
    infinite: true,
    speed: 600,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  const getData = async () => {
    try {
      const res = await axios.get(`${baseUrl}banner/public`, {
        withCredentials: true,
      });
      setData(res.data);
    } catch (error) {
      console.log("Server Error BannerList");
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <section className="bannerSection d-none">
        <div className="container">
          <Slider {...settings}>
            {data &&
              data.map((item) => {
                return (
                  item?.image?.url && (
                    <Link to={item?.url || ""} key={item._id}>
                      <div
                        className="bannerItem"
                        // style={!isMobile ? { height: "500px" } : {}}
                      >
                        <img
                          src={item?.image.url}
                          // className="aspect-ratio-img"
                        />
                      </div>
                    </Link>
                  )
                );
              })}
          </Slider>
        </div>
      </section>

      <section className="bannerSection ">
        <Slider {...settings}>
          <div>
            <div
              className="bannerContent"
              style={{
                backgroundImage: `url(${banner1})`,
                backgroundSize: "cover",
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="container">
                <div className="bannerDem">
                  <h4>Best Pharma Company</h4>
                  <h2>
                    We are dedicated to improving animal health and farm
                    productivity
                  </h2>
                  <p>
                    we are dedicated to improving animal health and farm
                    productivity through high-quality veterinary feed
                    supplements specially formulated for cattle and poultry.
                  </p>
                  <Link to={"/"} className="commonBtn">
                    Ask for Quote
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              className="bannerContent"
              style={{
                backgroundImage: `url(${banner2})`,
                backgroundSize: "cover",
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="container">
                <div className="bannerDem">
                  <h4>Best Pharma Company</h4>
                  <h2>
                    High-quality veterinary feed supplements for cattle and
                    poultry.
                  </h2>
                  <p>
                    we are dedicated to improving animal health and farm
                    productivity through high-quality veterinary feed
                    supplements specially formulated for cattle and poultry.
                  </p>
                  <Link to={"/"} className="commonBtn">
                    Ask for Quote
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>
    </>
  );
}

export default Banner;
